var _Path, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgTeamSports(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#team-sports_svg__clip0_3626_5233)",
    fill: props.fill
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M16.641 8.455c-.47.003-.955.057-1.403.14a7.63 7.63 0 00-2.467.936c-.018.011-.03.036-.048.047a10.487 10.487 0 00-4.16 4.538l-.086.18a1.55 1.55 0 102.803 1.326l.136-.29c.649-1.379 1.628-2.488 2.903-3.227l-4.5 10.385 2.807 1.216 1.646-3.542a.743.743 0 011.367.58l-2.973 7.703a1.545 1.545 0 002.878 1.123l6.612-16.764c.147.06 4.245 2.186 6.398 3.304a1.499 1.499 0 001.384-2.658l-5.895-3.079c-.992-.41-5.999-1.777-5.999-1.777a7.11 7.11 0 00-1.403-.14zM7.353 25.952c-1.71 0-3.096 1.34-3.096 2.994 0 1.653 1.386 2.994 3.096 2.994 1.71 0 3.096-1.34 3.096-2.994 0-1.654-1.386-2.994-3.096-2.994zM20.676 7.795a2.897 2.897 0 100-5.795 2.897 2.897 0 000 5.795z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "team-sports_svg__clip0_3626_5233"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(4.257 2)",
    d: "M0 0h26.487v29.94H0z"
  })))));
}

export default SvgTeamSports;